import useSWRMutation from 'swr/mutation';
import baseFetcher from '../../shared/baseFetcher';
import { KEY } from '../constants';

const getCreatePrequalUrl = (isReapply) => {
  if (isReapply) {
    return '/prequals/reapply';
  }
  return '/prequals';
};

const fetcher = (config, { arg: data }, isReapply) => baseFetcher({
  ...config,
  method: 'POST',
  url: getCreatePrequalUrl(isReapply),
  data,
});

const useCreatePrequal = ({ isReapply, ...options } = {}) => (
  useSWRMutation(KEY, (...args) => fetcher(...args, isReapply), {
    ...options,
    populateCache: true,
    revalidate: false,
  })
);

export default useCreatePrequal;
